(function FranchiseListReviewMultiple($, Adzuki)
{
	'use strict';

	Adzuki.onload('FranchiseLists/reviewMultiple/', init, false);

	function init()
	{
		$('.delete-client-from-list').on('click', deleteClientFromList);
	}

	function deleteClientFromList(e)
	{
		e.preventDefault();

		const $link     = $(this);
		const list_id   = $link.data('list-id');
		const client_id = $link.data('client-id');
		const message   = 'Removing this client will put you under your allotment for this list. Please remember to go back to your Smart Select list and add another client to replace this one.<br><br>Are you sure you wish to remove this client?';

		Adzuki.CustomConfirm({
			close_icon: true,
			body      : message,
			confirm   : async function confirm() {
				const response = await Adzuki.Ajax.get('/FranchiseLists/removeClientFromList/' + list_id + '/' + client_id);

				if (response.error) {
					Adzuki.StatusMessage('error', response.error);
					return;
				}

				// remove the list name and the delete link
				const $list_name   = $link.parents('.ss-list-name');
				const $list_parent = $list_name.parent();

				$list_name.remove();

				// if there's one list left, then remove the row from the table
				if ($list_parent.find('.ss-list-name').length <= 1) {
					$list_parent.parents('.table-row').remove();
				}

				Adzuki.StatusMessage('success', 'The client has been removed from the list');
			}
		});
	}
}(jQuery, window.Adzuki || {}));
